import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import infoCircle from '../../assets/images/attention-icon.svg';
import { personalInformationLine } from './util';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const ReviewPersonalInformation = ({ customer, disabled, handleClick }) => (
  <div className="review-customer-information">
    <div className="section-header">
      <SectionHeading text="My Personal Information">
        {!disabled && (
          <EditButton onClick={handleClick('info')} currentlyEditing={false} />
        )}
      </SectionHeading>
    </div>
    <div className="customer-information-lines">
      {disabled && (
        <div>
          <img
            src={infoCircle}
            className="info-circle"
            alt="update-information"
          />
          <span className="update-label">
            To update your personal information, visit your account dashboard
          </span>
        </div>
      )}
      <div
        data-name={generateGeneralTestID(
          'Review',
          'AccountOwnerPersonalInformation'
        )}
        className="nasu_masking_class">
        {personalInformationLine(customer)}
      </div>
    </div>
    <style jsx>{styles}</style>
  </div>
);

export default ReviewPersonalInformation;
